import { IAjax } from 'lib/Ajax';
import { AutoSavingDraftObject } from 'lib/autoSave';
import { PhoneNumber as ServerPhoneNumber } from 'data/models/PhoneNumber';
import { PhoneNumberKind } from 'server/enums/PhoneNumberKind';

export type PhoneNumber = ReturnType<typeof PhoneNumber>;
export function PhoneNumber(ajax : IAjax, phoneNumber : ServerPhoneNumber, onDeleted : (ts : Date) => void) {
    let client = ajax.Url<ServerPhoneNumber>(() => phoneNumber.Url() || ''),
        draft = AutoSavingDraftObject(phoneNumber, client);

    return {
        Model: draft,
        Delete: Delete
    };

    function Delete() {
        let req = client.Delete();
        req.then(() =>
            onDeleted(req.Date)
        );
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/phonenumber/model.ts